import React from 'react';
import './Contact.css';
import avatar from './mg.png';
import { FaLinkedin, FaInstagram, FaEnvelope, FaFacebook } from 'react-icons/fa'; // Icons

function Contact() {
  return (
    <section id='contact' className="contact-section">
      <div className="contact-content">
        <div className="contact-left">
          <img src={avatar} alt="Profile" className="profile-img" />
        </div>
        <div className="contact-right">
          <p>Are you interested to team up?</p>

          <a
            href="https://www.linkedin.com/in/mary-grace-benbenuto-7222b6347/"
            className="contact-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin style={{ marginRight: '8px' }} />
            LinkedIn
          </a>

           <a
            href="https://www.facebook.com/profile.php?id=61561380692949"
            className="contact-btn"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook style={{ marginRight: '8px' }} />
            Faceook
          </a>

          <a
            href="mailto:marygrace.b.benbenuto@gmail.com"
            className="contact-btn"
          >
            <FaEnvelope style={{ marginRight: '8px' }} />
           marygrace.b.benbenuto@gmail.com
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
